import cookie from "js-cookie";
import jwt_decode from "jwt-decode";
import { io, Socket } from "socket.io-client";

const URL: string = process.env.REACT_APP_SOCKET_ENDPOINT || "http://localhost:8080";

let socketInstance: Socket;
const socketEventEmitter = new EventTarget();

const decoedJWT = () => {
  try {
    const token = cookie.get("token");
    const decodedToken: any = jwt_decode(token as string);
    return decodedToken.sourceId as string;
  } catch (e) {
    return "";
  }
};

const createSocketConnection = (accessToken?: string): Socket => {
  const token = accessToken || cookie.get("token");
  return io(URL, {
    withCredentials: true,
    transports: ["websocket"],
    auth: {
      token,
      userId: decoedJWT(),
    },
  });
};

// Initialize socket
socketInstance = createSocketConnection();

// Add error handling
socketInstance.on("connect_error", (error) => {
  console.error("Socket connection error details:", error.message);
});

socketInstance.on("error", (error) => {
  console.error("Socket general error:", error);
});

socketInstance.on("connect", () => {
  if (process.env.NODE_ENV === "development") {
    console.log("Socket connected successfully with ID:", socketInstance.id);
  }
  // Emit custom event for application listeners to re-register
  socketEventEmitter.dispatchEvent(
    new CustomEvent("socket-reconnected", {
      detail: { socketId: socketInstance.id },
    })
  );
});

socketInstance.on("disconnect", (reason) => {
  if (process.env.NODE_ENV === "development") {
    console.log("Socket disconnected:", reason);
  }
});

// Function to reconnect with new token
export const reconnectSocket = (accessToken?: string): Socket => {
  if (process.env.NODE_ENV === "development") {
    console.log("Reconnecting socket with new token...");
  }

  // Disconnect existing socket
  if (socketInstance) {
    socketInstance.removeAllListeners();
    socketInstance.disconnect();
  }

  // Create new socket instance with fresh token
  socketInstance = createSocketConnection(accessToken);

  // Re-add basic event listeners
  socketInstance.on("connect_error", (error) => {
    if (process.env.NODE_ENV === "development") {
      console.error("Socket connection error details:", error.message);
    }
  });

  socketInstance.on("error", (error) => {
    if (process.env.NODE_ENV === "development") {
      console.error("Socket general error:", error);
    }
  });

  socketInstance.on("connect", () => {
    if (process.env.NODE_ENV === "development") {
      console.log("Socket reconnected successfully with ID: - ", socketInstance.id);
    }
    // Emit custom event for application listeners to re-register
    socketEventEmitter.dispatchEvent(
      new CustomEvent("socket-reconnected", {
        detail: { socketId: socketInstance.id },
      })
    );
  });

  socketInstance.on("disconnect", (reason) => {
    if (process.env.NODE_ENV === "development") {
      console.log("Socket disconnected:", reason);
    }
  });

  return socketInstance;
};

export const getSocket = (): Socket => socketInstance;
export const onSocketReconnected = (callback: (event: CustomEvent) => void) => {
  socketEventEmitter.addEventListener("socket-reconnected", callback as EventListener);
};
export const offSocketReconnected = (callback: (event: CustomEvent) => void) => {
  socketEventEmitter.removeEventListener("socket-reconnected", callback as EventListener);
};
export { socketInstance as socket };
